import '../../core/components/app-root/AppRoot.css';
import '../../styles/textStyle.css';
import '../spin-buttons/SpinButton.css';
import './DateTimePicker.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var clearIconButton = '_1i883gjh-3-5-0';
export var dateSelector = '_1i883gjg-3-5-0';
export var dateTimePicker = _7a468({defaultClassName:'_1i883gj7-3-5-0',variantClassNames:{readOnly:{true:'_1i883gj8-3-5-0'},showError:{true:'_1i883gj9-3-5-0'},disabled:{true:'_1i883gja-3-5-0'},type:{date:'_1i883gjb-3-5-0',time:'_1i883gjc-3-5-0',datetime:'_1i883gjd-3-5-0'}},defaultVariants:{},compoundVariants:[[{readOnly:true,showError:true},'_1i883gje-3-5-0']]});
export var spinButtonGroup = '_1i883gjf-3-5-0 _da9a8v0-3-5-0 _da9a8v2-3-5-0 _da9a8v3-3-5-0 _da9a8vb-3-5-0';
export var spinButtonSelectionBackgroundColorVar = 'var(--_1i883gj6-3-5-0)';
export var spinButtonSelectionColorVar = 'var(--_1i883gj5-3-5-0)';